import {useAppSelector} from "../../../../../../redux/hooks";
import {musicHomeStore} from "../../../../../songs-router/modules/music-home-store/musicHomeStore";

export interface IMusicHomeMobileSearchControlAccessLogic {
  isMobileSearchActive: boolean;
  isFiltersActive: boolean;
  handleMobileSearchDisplayToggle: () => void;
}

export const useMusicHomeMobileSearchControlAccessLogic = (): IMusicHomeMobileSearchControlAccessLogic => {
  const isMobileMenuActive = useAppSelector(musicHomeStore.isMobileSearchActive);
  const doesSearchHaveValue = useAppSelector(musicHomeStore.doesMobileSearchHaveText);

  const isMobileSearchActive: boolean = (isMobileMenuActive || doesSearchHaveValue);

  return {
    isMobileSearchActive,
    isFiltersActive: false,
    handleMobileSearchDisplayToggle: musicHomeStore.toggleMobileSearchControls,
  };
}
